module.exports = __webpack_public_path__ + "img/pic_name_sd.5423479c.png";